import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string()
    .required("Please enter name"),
    number: Yup.string().nullable(),
    color: Yup.string().required("Please select a color")
});